/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
import 'APP_THEME/start_page/start/all_cards.less';
import 'resources/less/themes/base/widgets/standalone/reviews.less';
import 'resources/less/themes/base/pages/standalone/all_products.less';
import 'resources/less/themes/base/widgets/featured_product_blocks.less';

import 'APP_THEME/_common/legacy/core';
import 'assets/js/start/pricingLoader';
import 'assets/js/slider';

import screen from 'assets/js/modules/screen';
import OnpStartPageView from 'assets/js/modules/themes/OvernightPrints/modules/pages/start/view/startPageView';
import facebook from 'assets/js/modules/api/facebook';
import StartPageInit from 'APP_THEME/_common/start_page/start/index';

$(function() {
    const startPageInit = new StartPageInit('.start-page', {
        showDvsDesigner: false,
        showUploadInfo: true,
        handleBannerClicks: false,
        StartPageView: OnpStartPageView,
        galleryBlockSize: 6
    });

    $('.featured-product-blocks').on('click', '.featured-product-block', function() {
        var link = $(this)
            .find('.featured-product-link')
            .attr('href');
        if (link) {
            window.location.href = link;
        }
    });

    if (screen.isBig()) {
        $('.featured-products-slider').each(function(index, el) {
            $($(el).find('.featured-product-blocks')).sliderAction({
                listParent: $(el).find('.featured-products-trimmer'),
                listClass: '.featured-product-container',
                next: $(el).find('.next'),
                prev: $(el).find('.prev')
            });
        });
    }

    facebook.loadSdk();
});
